import { render, staticRenderFns } from "./entranceGuardSoftware.vue?vue&type=template&id=dda6bbe8&scoped=true&"
import script from "./entranceGuardSoftware.vue?vue&type=script&lang=js&"
export * from "./entranceGuardSoftware.vue?vue&type=script&lang=js&"
import style0 from "./entranceGuardSoftware.vue?vue&type=style&index=0&id=dda6bbe8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda6bbe8",
  null
  
)

export default component.exports